import { useDispatch } from 'react-redux';
import { AppDispatch } from '../stores/store';
import { API_CODE } from '../_constants/apiConst';
import { postHistory } from '../stores/history/slice';
import { isFulfilled } from '@reduxjs/toolkit';

const useSaveHistory = () => {
  const dispatch: AppDispatch = useDispatch();

  /** 操作履歴の保存 */
  const saveHistory = async (
    historyData: { rmaNo: string; serialNo: string; companyKey: string },
    status: number,
    type: number,
    onCloseCallback: (() => void) | (() => Promise<void>),
    showApiError: (
      apiError: unknown,
      apiCode: string,
      onCloseCallback?: () => void,
    ) => void,
    item = '',
  ) => {
    const response = await dispatch(
      postHistory({
        rmaNo: historyData.rmaNo,
        serialNo: historyData.serialNo,
        companyKey: historyData.companyKey,
        status,
        type,
        item,
      }),
    );

    // 成功時、画面遷移
    if (isFulfilled(response)) {
      onCloseCallback();
      return;
    }

    // 失敗時、エラーを表示して画面遷移
    showApiError(response.payload, API_CODE.OPERATION_HISTORY, onCloseCallback);
  };

  return saveHistory;
};

export default useSaveHistory;
